<template>
  <div
    class="content"
    :style="{
      backgroundColor: colors.mainColor,
      backgroundImage: `url(${info && info.back_img ? info.back_img : ''})`,
    }"
  >
    <div class="ctx" :class="[`page-style-${styleType}`]" v-if="info" v-show="!cover">
      <div class="banner">
        <img :src="info.banner" />
      </div>
      <div class="live-area default-cover" v-if="hide" @click="showAuth"></div>
      <div class="live" v-else>
        <div class="live-area">
          <video
            controls
            :poster="live.url"
            :src="live.link"
            autoplay
            type="video/mp4"
            webkit-playsinline
            playsinline
            x5-video-player-type="h5"
            x5-video-player-fullscreen="true"
            x-webkit-airplay="allow"
            x5-video-orientation="portraint"
            class="like-video"
            v-if="live && live.is_live == 2"
          ></video>
          <div class="frame-box" v-else>
            <iframe
              :src="convertHttps(live.link || info.url)"
              width="100%"
              height="100%"
              frameborder="0"
              allowfullscreen
            ></iframe>
          </div>
        </div>
        <live-status :live="live" @share="tipShow = true" v-if="live.is_live == 1" />
        <div class="live-location" @click="goToMap" v-if="position && styleType == 2">
          <div class="icon-location live-location-icon"></div>
          <div class="live-location-address">{{position.name}}</div>
        </div>
      </div>
      <like
        :info="info"
        :colors="colors"
        :type="listType"
        :style-type="styleType"
        :show-start="showStart"
        @share="tipShow = true"
        @change="handleListChange"
        v-if="!hide"
      ></like>
      <div class="detail">
        <div class="tab" v-if="tabs && tabs.length > 0">
          <div
            class="tab-item"
            :class="{ active: tab == i }"
            :style="{
              backgroundColor: tab == i ? colors.cxtBackColor : 'transparent',
              color: tab == i ? colors.tabActiveColor : colors.tabTextColor,
            }"
            @click="tab = i"
            v-for="(t, i) in tabs"
            :key="i"
          >
            {{ t.name }}
          </div>
        </div>
        <div
          class="tab-ctx"
          :class="{ left: tab == 0, right: tab == tabs.length - 1 }"
          :style="{ backgroundColor: colors.cxtBackColor, color: colors.c }"
          v-show="tab == i"
          v-for="(t, i) in tabs"
          :key="i"
          v-html="t.content"
        ></div>
        <div
          class="location"
          :style="{ backgroundColor: colors.cxtBackColor }"
          v-if="position && styleType == 1"
        >
          <div class="loc-ti">
            <div class="icon-location loc-ti-icon"></div>
            <div class="loc-ti-txt">直播位置</div>
          </div>
          <div class="loc-map" @click="goToMap">
            <div class="loc-map-box" id="map"></div>
            <div class="loc-map-position" v-if="false">
              <div class="icon-location loc-ti-icon"></div>
              <div class="loc-position-text">{{ position.name }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="tip" v-if="info === false">直播活动已下线</div>
    <transition name="fade">
      <div class="cover" v-if="info && info.cover && cover">
        <img :src="info.cover" @load="hideCover" />
      </div>
    </transition>
    <transition name="fade">
      <div class="share-tip" v-show="tipShow" @click="tipShow = false">
        <img src="../assets/point.png" class="share-tip-point" />
        <div class="share-tip-img"></div>
        <div class="share-tip-text">
          立即分享给好友吧<br />
          点击屏幕右上角将本页面分享给好友
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
/* global qq:false */
import { wxConf } from "../common/wxTool";
import { overscroll } from "../common/tool";
import LiveStatus from "../components/live-count/LiveStatus";
import like from "../components/like";
import { dealLive } from "../common/live";
import {QQ_MAP_KEY} from "@/common/config";

export default {
  name: "Frame",
  components: {
    like,
    LiveStatus
  },
  data() {
    return {
      tab: 0,
      cover: true,
      info: null,
      tabs: [],
      position: null,
      colors: {},
      collect: [],
      live: {},
      authed: false,
      showStart: false,
      listType: 0,
      styleType: 0,
      ms: false,
      tipShow: false,
      user: null,
    };
  },
  // watch: {
  //   styleType(val) {
  //     this.$nextTick(() => {
  //       if(val == 2) {
  //         overscroll(document.querySelector(".call-content"));
  //       } else {
  //         overscroll(document.querySelector(".content"));
  //       }
  //     })
  //   }
  // },
  computed: {
    hide() {
      const info = this.info;
      return (!info || info.needPass == 1) && !this.authed;
    },
  },
  created() {
    this.getLiveInfo();
  },
  mounted() {
    overscroll(document.querySelector(".content"));
  },
  methods: {
    convertHttps(url) {
      return url ? url.replace("http://", "https://") : url;
    },
    handleListChange(s) {
      this.live = s;
    },
    getLiveInfo() {
      let alias = this.$route.params.alias;
      this.$showLoading();
      this.$axios({
        url: "/activity-live/detail?alias=" + alias,
        loadingText: false,
      }).then((res) => {
        if (res) {
          this.dealInfo(res);
          this.$hideLoading();
        }
        // else {
        //   this.info = false;
        // }
      });
    },
    dealInfo(info) {
      document.title = info.title;
      let conf = JSON.parse(info.num_config);
      if (conf.listType) {
        this.listType = conf.listType * 1;
      }
      this.styleType = conf.styleType ? conf.styleType * 1 : 1;
      if (conf.showStart == 1) {
        this.showStart = true;
      }
      let color = info.color;
      if (color) {
        if (color.startsWith("#")) {
          this.colors = {
            mainColor: color,
          };
        } else {
          this.colors = JSON.parse(color);
        }
      }
      let position = JSON.parse(info.location);
      if (position.has) {
        this.position = position;
      }
      info.view_count = conf.num;
      dealLive(info);
      this.tabs = JSON.parse(info.tab);
      this.info = info;
      this.init();
      if (info.needPass == 1) {
        this.showAuth();
      }
    },
    goToMap() {
      let position = this.position;
      location.href = `https://apis.map.qq.com/tools/poimarker?type=0&marker=coord:${position.latLng};title:${position.name}&key=${QQ_MAP_KEY}&referer=forum;`;
    },
    hideCover() {
      setTimeout(() => {
        this.cover = false;
        this.$nextTick(this.mapInit);
      }, 2000);
    },
    showAuth() {
      let password = "";
      this.$showDialog({
        title: "请输入直播间密钥",
        hold: true,
        text: (
          <div class="live-pass">
            <input
              type="password"
              class="live-pass-input"
              v-model={password}
              placeholder="请输入"
            />
          </div>
        ),
        fn: () => {
          if (password) {
            const url = `/activity-live?filter[id]=${this.info.id}&filter[pass_text]=${password}`;
            this.$axios(url).then((res) => {
              if (res.data.length > 0) {
                const live = res.data[0];
                this.authed = true;
                this.$set(this.info, "url", live.url);
                this.$hideDialog();
              } else {
                this.$toast("密钥不正确");
              }
            });
          } else {
            this.$toast("请输入直播间密钥");
          }
        },
      });
    },
    init() {
      let info = this.info;
      if (info.cover) {
        this.cover = true;
      } else {
        this.cover = false;
        this.$nextTick(this.mapInit);
      }
      this.wxInit();
    },
    wxInit() {
      let info = this.info;
      let imgUrl =
        info.share_logo ||
        "https://zk-static-1301841918.cos.ap-nanjing.myqcloud.com/share.jpg";
      let title = info.share_title || info.title;
      let desc = info.share_desc || info.title;
      wxConf(title, desc, imgUrl);
    },
    mapInit() {
      let position = this.position;
      if (position) {
        let latLng = position.latLng.split(",");
        let center = new qq.maps.LatLng(latLng[0], latLng[1]);
        this.hotelMap = new qq.maps.Map(document.getElementById("map"), {
          // 地图的中心地理坐标。
          zoom: 16,
          disableDefaultUI: true,
          center,
        });
        new qq.maps.Marker({
          position: center,
          map: this.hotelMap,
        });
      }
    },
  },
};
</script>

<style lang="less">
@import "../common/less/frame-new";
.content {
  background: center top;
  background-size: cover;
}
.cover {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  font-size: 0;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.share-tip {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
}
.share-tip-point {
  position: absolute;
  width: 120px;
  height: 120px;
  top: 0;
  right: 32px;
}
.share-tip-img {
  margin: 164px auto 0;
  width: 686px;
  height: 472px;
  background: url(../assets/share-img.png) center / contain no-repeat;
}
.share-tip-text {
  margin-top: 60px;
  font-size: 34px;
  line-height: 48px;
  text-align: center;
  letter-spacing: 1px;
  color: #ffffff;
}
.c-ctx {
  position: relative;
}
.live-area {
  position: relative;
  height: 422px;
  background-color: #000;
  &.default-cover {
    background: url(https://zk-static-1301841918.cos.ap-nanjing.myqcloud.com/topic/live.jpg)
      center / cover no-repeat;
  }
  &::before {
    content: "\e601";
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    width: 100px;
    height: 100px;
    font-size: 100px;
    font-family: iconfont;
    line-height: 100px;
    color: #fff;
  }
}
.like-video {
  position: relative;
  width: 100%;
  height: 100%;
}
.frame-box {
  position: relative;
  width: 100%;
  height: 100%;
}
.foot {
  margin-top: 70px;
  padding: 0 90px;
  font-family: STFangsong;
  font-size: 24px;
  font-weight: 600;
  line-height: 1.8;
  p {
    margin: 0;
  }
}
.tab {
  display: flex;
  margin-top: 32px;
}
.tab-ctx {
  padding: 10px;
  background-color: #fff;
  border-radius: 15px;
  &.left {
    padding: 20px;
    border-top-left-radius: 0;
  }
  &.right {
    border-top-right-radius: 0;
  }
}
.tab-item {
  flex: 1;
  height: 60px;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  font-size: 32px;
  color: #9d9d9d;
  line-height: 60px;
  text-align: center;
  &.active {
    background-color: #fff;
    color: #148bff;
  }
}
.show-list {
  width: 100%;
}
.intro {
  margin: 0;
  text-indent: 2em;
  font-size: 24px;
  color: #666;
  line-height: 1.5;
  text-align: justify;
}
.location {
  margin-top: 32px;
  padding: 24px;
  background-color: #fff;
  border-radius: 15px;
}
.loc-ti {
  display: flex;
  align-items: center;
  height: 48px;
}
.loc-ti-icon {
  width: 32px;
  height: 32px;
  font-size: 32px;
  line-height: 32px;
  color: #00aaff;
}
.loc-ti-txt {
  margin-left: 8px;
  color: #121212;
  font-size: 32px;
}
.loc-map {
  position: relative;
  margin-top: 32px;
  height: 220px;
  border-radius: 16px;
}
.loc-map-box {
  height: 100%;
  border-radius: 16px;
}
.loc-map-position {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.loc-position-text {
  font-size: 32px;
  color: #121212;
  text-shadow: 0 8px 8px rgba(0, 0, 0, 0.25);
}
.live-pass {
  margin: 0 48px 48px;
  border-bottom: var(--border);
  .live-pass-input {
    width: 100%;
    height: 96px;
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
